import React, { useState, useEffect } from "react";

const MobileAppBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner
    const dismissed = localStorage.getItem("mobileAppBannerDismissed");
    if (dismissed === "true") {
      setIsDismissed(true);
      return;
    }

    // Detect mobile device
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth <= 768;

    if (isMobile) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  // Add padding to body when banner is visible
  useEffect(() => {
    if (isVisible && !isDismissed) {
      document.body.style.paddingBottom = "80px";
    } else {
      document.body.style.paddingBottom = "";
    }

    return () => {
      document.body.style.paddingBottom = "";
    };
  }, [isVisible, isDismissed]);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    localStorage.setItem("mobileAppBannerDismissed", "true");
  };

  const handleDownload = (store) => {
    // You can replace these URLs with your actual app store links
    const appStoreUrl = "https://apps.apple.com/eg/app/abdelaziz-elsallab-stores/id6741209974"; // Replace with your App Store URL
    const playStoreUrl = "https://play.google.com/store/apps/details?id=com.electronss.elsallab_customer.flutter_odoo_customer_sallab&hl=en&pli=1"; // Replace with your Play Store URL

    if (store === "ios") {
      window.open(appStoreUrl, "_blank");
    } else {
      window.open(playStoreUrl, "_blank");
    }
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#0e5aa7",
        color: "#ffffff",
        padding: "12px 16px",
        zIndex: 9999,
        boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        animation: "slideUp 0.3s ease-out",
      }}
    >
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "4px",
          }}
        >
          Get the best experience
        </div>
        <div
          style={{
            fontSize: "12px",
            opacity: 0.9,
          }}
        >
          Download our mobile app for optimal viewing
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <button
          onClick={() => handleDownload("ios")}
          style={{
            backgroundColor: "#ffffff",
            color: "#0e5aa7",
            border: "none",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          App Store
        </button>
        <button
          onClick={() => handleDownload("android")}
          style={{
            backgroundColor: "#ffffff",
            color: "#0e5aa7",
            border: "none",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          Play Store
        </button>
        <button
          onClick={handleDismiss}
          style={{
            backgroundColor: "transparent",
            color: "#ffffff",
            border: "none",
            padding: "4px 8px",
            cursor: "pointer",
            fontSize: "18px",
            lineHeight: "1",
            opacity: 0.8,
            transition: "opacity 0.2s",
            flexShrink: 0,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default MobileAppBanner;

